import { beat } from './story';

/*
 * Typing, as story beats: one beat per character, so the text a real
 * controlled input shows grows on the story's own clock (it pauses, resumes
 * and rewinds with everything else). The scene reads how much is typed with
 * storyAt(...).typed(id, text) and hands that to the input as its value;
 * TypingCaret draws the caret after it.
 *
 * The two speeds, TYPE_NUMBER_MS and TYPE_SENTENCE_MS, live with the knob
 * (tempo.js), so a vignette that types without beats (Home's Lab cell)
 * reads them there.
 */
export { TYPE_NUMBER_MS, TYPE_SENTENCE_MS } from './tempo';

/**
 * The beats that type `text`, `id.1` to `id.N`: the first `first` script ms
 * after the beat before it, then one every `perChar` script ms.
 */
export function typing(id, text, { perChar, first = perChar }) {
    return [...text].map((_, index) => beat(`${id}.${index + 1}`, index === 0 ? first : perChar, { typing: id }));
}
